import React from "react";
import { motion } from "framer-motion";
function WorkFlows() {
  return (
    <div className="w-full bg-black pt-10 lg:px-32 px-10 lg:h-[506px] h-[400px]">
      <motion.div
        initial={{ rotateX: -90, opacity: 0 }}
        whileInView={{ rotateX: 0, opacity: 1 }}
        transition={{ duration: 2, ease: "easeInOut" }}
        viewport={{ once: true }}
        className=" w-full shadow-custom py-5 rounded-xl flex flex-col lg:gap-y-3 gap-y-6 items-center justify-center"
      >
        <span className="lg:text-[48px] text-[28px] text-center leading-tight font-bold text-[#ECECEC]">
          Transforming Judicial <br /> Workflows with AI
        </span>
        <span className="lg:text-lg text-sm font-normal text-[#ECECEC] text-center">
          Optimize judicial workflows through the strategic <br />{" "}
          implementation of AI technologies.
        </span>

        <span className="w-[186px] h-[48px] rounded-3xl text-white justify-center items-center flex border border-[#ECECEC] text-[16px] text-xs">
          Our app coming soon
        </span>
      </motion.div>
    </div>
  );
}

export default WorkFlows;
